import { useState, useMemo } from "react";
import type { Word } from "@/types/word";

export const useDictionaryFilters = (words: Word[]) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const categories = useMemo(() => {
    const uniqueCategories = [...new Set(words.map((w) => w.category))];
    return uniqueCategories.sort();
  }, [words]);

  const filteredWords = useMemo(() => {
    return words.filter((word) => {
      const matchesSearch =
        word.word.toLowerCase().includes(searchTerm.toLowerCase()) ||
        word.definition.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory = selectedCategory
        ? word.category === selectedCategory
        : true;
      return matchesSearch && matchesCategory;
    });
  }, [words, searchTerm, selectedCategory]);

  const groupedWords = useMemo(() => {
    const grouped: Record<string, Word[]> = {};
    filteredWords.forEach((word) => {
      const firstLetter = word.word[0].toUpperCase();
      if (!grouped[firstLetter]) {
        grouped[firstLetter] = [];
      }
      grouped[firstLetter].push(word);
    });
    return grouped;
  }, [filteredWords]);

  return {
    searchTerm,
    setSearchTerm,
    selectedCategory,
    setSelectedCategory,
    categories,
    filteredWords,
    groupedWords,
  };
};
